<!--suppress CheckEmptyScriptTag -->
<template>
  <svg version="1.1"
       id="heart"
       xmlns="http://www.w3.org/2000/svg"
       x="0px"
       y="0px"
       viewBox="0 0 32 32"
       xml:space="preserve">
    <path fill="none"
          stroke="#796E65"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="M16,5.8 C12.5,1.9,7.3,1.4,4.4,4.7c-2.9,3.3-2.4,9.1,1.1,13L16,29.5l10.5-11.8c3.5-3.9,4-9.7,1.1-13S19.5,1.9,16,5.8z"
          class="stroke"/>
  </svg>
</template>

<script>
/**
 * SVG icon.
 */
export default {
  name: 'SvgHeart'
}
</script>
